import { render, staticRenderFns } from "./DemandDetailSupplier.vue?vue&type=template&id=bd3cae0c&scoped=true"
import script from "./DemandDetailSupplier.vue?vue&type=script&lang=js"
export * from "./DemandDetailSupplier.vue?vue&type=script&lang=js"
import style0 from "./DemandDetailSupplier.vue?vue&type=style&index=0&id=bd3cae0c&prod&lang=css"
import style1 from "./DemandDetailSupplier.vue?vue&type=style&index=1&id=bd3cae0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3cae0c",
  null
  
)

export default component.exports